// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sB6Fb","title":"styles_title__2pjqn"};